import Model from '@/core/models/Model';

export default class Gender extends Model {
  resource() {
    return 'misc/user-genders';
  }
}
